var map = {
	"./CEX/OGEX/OGEX-1.svg": 11600,
	"./CEX/OGEX/OGEX.svg": 8473,
	"./CEX/SVG/GS logo white.svg": 82571,
	"./CEX/SVG/GS logo.svg": 39788,
	"./CEX/SVG/GS studio white.svg": 5388,
	"./CEX/SVG/Group 111.svg": 81505,
	"./CEX/SVG/Group 112.svg": 88370,
	"./CEX/SVG/META white.svg": 60057,
	"./CEX/SVG/META.svg": 29974,
	"./CEX/SVG/OG-logo white.svg": 44514,
	"./CEX/SVG/OG-logo.svg": 87061,
	"./CEX/SVG/OGEX white.svg": 61303,
	"./CEX/SVG/OGEX.svg": 95440,
	"./CEX/SVG/Subtract.svg": 34161,
	"./CEX/SVG/Vector.svg": 99012,
	"./CEX/SVG/W3G white.svg": 40393,
	"./CEX/SVG/gamestarter.svg": 64860,
	"./InviteFriends_bt.svg": 26184,
	"./Lightbulb.svg": 2424,
	"./about/bgr-policy.svg": 94001,
	"./add_input.svg": 20321,
	"./api-icon.svg": 3573,
	"./app-store.svg": 27560,
	"./arrow-down.svg": 663,
	"./arrow-left.svg": 42600,
	"./arrow-pagination.svg": 86843,
	"./back_icon.svg": 25286,
	"./background-login.svg": 25819,
	"./banner-phone-number.svg": 60360,
	"./bell.svg": 6036,
	"./bgr-open-history-mobile.svg": 33261,
	"./bgr-open-history.svg": 7726,
	"./bgr-order-mobile.svg": 78994,
	"./bgr-order.svg": 48531,
	"./bgr-trade-history.svg": 10382,
	"./bgr-wallet.svg": 45998,
	"./blue-google-icon.svg": 89117,
	"./blue-logo.svg": 45905,
	"./change-password.svg": 21764,
	"./china-flag.svg": 70175,
	"./close.svg": 7733,
	"./conversion-history-dark.svg": 91505,
	"./conversion-history-light.svg": 26807,
	"./convert-icon-dark.svg": 8535,
	"./convert-icon-light.svg": 16709,
	"./copy-icon.svg": 48226,
	"./default-avatar.svg": 85140,
	"./delete-icon-dark.svg": 78825,
	"./delete-icon.svg": 67348,
	"./delete_input.svg": 43803,
	"./deposit_icon.svg": 37413,
	"./deposit_icon_dark.svg": 24388,
	"./dot-more.svg": 13034,
	"./down-arrow.svg": 75927,
	"./edit-icon-dark.svg": 3304,
	"./edit-icon.svg": 4315,
	"./email-icon.svg": 17405,
	"./eye-close.svg": 52045,
	"./eye-open.svg": 54263,
	"./fee-wallet.svg": 10621,
	"./fincen/fincen-registration.svg": 12466,
	"./fincen/fincen.svg": 82004,
	"./future-icon.svg": 25160,
	"./future-wallet.svg": 78100,
	"./google-authen-blue.svg": 87025,
	"./google-authentication.svg": 10827,
	"./google-play.svg": 67217,
	"./grey-lock.svg": 55550,
	"./home/arrow-right.svg": 82949,
	"./home/icon-android-dark.svg": 55701,
	"./home/icon-android.svg": 39368,
	"./home/icon-api-dark.svg": 39538,
	"./home/icon-api.svg": 47585,
	"./home/icon-apple-dark.svg": 97146,
	"./home/icon-apple.svg": 28761,
	"./home/icon-check-dark.svg": 47354,
	"./home/icon-check.svg": 76537,
	"./home/icon-copy.svg": 88848,
	"./home/icon-google-play-dark.svg": 97986,
	"./home/icon-google-play.svg": 48849,
	"./home/icon-mac-dark.svg": 2145,
	"./home/icon-mac.svg": 33628,
	"./home/icon-people.svg": 28318,
	"./home/icon-window-dark.svg": 63440,
	"./home/icon-window.svg": 8979,
	"./home/ip14pro.svg": 32886,
	"./home/qr-dark.svg": 31525,
	"./home/qr.svg": 54296,
	"./icomoon.svg": 9149,
	"./icon-convert-history.svg": 9185,
	"./icon-dropdown-2-dark.svg": 69524,
	"./icon-dropdown-2.svg": 23247,
	"./icon-star-reward-dark.svg": 93256,
	"./icon-success-2-dark.svg": 71456,
	"./icon-success-2.svg": 80835,
	"./icon-success.svg": 89618,
	"./icon-transaction.svg": 49671,
	"./icon-width.svg": 96711,
	"./icon-x-dark.svg": 43392,
	"./icon-x.svg": 36899,
	"./icon/404.svg": 44297,
	"./icon/FAQ.svg": 66085,
	"./icon/PWChange.svg": 85916,
	"./icon/Vector.svg": 12042,
	"./icon/api_management.svg": 6581,
	"./icon/arrow-down-black-base-dark.svg": 43878,
	"./icon/arrow-down-black-base.svg": 51789,
	"./icon/arrow-down-black.svg": 57209,
	"./icon/arrow-down-blue.svg": 73444,
	"./icon/arrow-down-white.svg": 42447,
	"./icon/arrow-right.svg": 73935,
	"./icon/arrow-up-blue.svg": 40801,
	"./icon/asset-dashboard.svg": 49618,
	"./icon/asset-main.svg": 87357,
	"./icon/asset-membership.svg": 45126,
	"./icon/asset-open-order.svg": 39105,
	"./icon/asset-order-history.svg": 53977,
	"./icon/asset-referral.svg": 81685,
	"./icon/asset-reward.svg": 42883,
	"./icon/asset-trade-history.svg": 73583,
	"./icon/bitcoin.svg": 48483,
	"./icon/callendar-range-dark.svg": 33048,
	"./icon/callendar-range-light.svg": 72952,
	"./icon/cancel-gi.svg": 89290,
	"./icon/change.svg": 34571,
	"./icon/check-gi.svg": 28262,
	"./icon/chip.svg": 24345,
	"./icon/code.svg": 17720,
	"./icon/coin/binance-ico.svg": 16435,
	"./icon/coin/bitcoin-ico.svg": 15199,
	"./icon/coin/btc.svg": 81184,
	"./icon/coin/cindicator-ico.svg": 46405,
	"./icon/coin/eth.svg": 2972,
	"./icon/coin/iconom-ico.svg": 37564,
	"./icon/coin/omisego_ico.svg": 84204,
	"./icon/coin/ripple_ico.svg": 36535,
	"./icon/coin/tetherUS-ico.svg": 64935,
	"./icon/coin/tetherum-ico.svg": 35753,
	"./icon/coin/usd.svg": 15925,
	"./icon/coin/usdt.svg": 62563,
	"./icon/collapse_18_18.svg": 13294,
	"./icon/confirmRemove-dark.svg": 79158,
	"./icon/confirmRemove.svg": 17789,
	"./icon/confirmed-withdrawal-dark.svg": 93239,
	"./icon/confirmed-withdrawal.svg": 45902,
	"./icon/cons_pin.svg": 85056,
	"./icon/convert.svg": 78692,
	"./icon/copper-icon.svg": 16066,
	"./icon/copy-dark.svg": 38629,
	"./icon/copy.svg": 94296,
	"./icon/dashboard.svg": 76357,
	"./icon/date-tim-order-dark.svg": 54066,
	"./icon/date-time-home-dark.svg": 81130,
	"./icon/date-time-order.svg": 32628,
	"./icon/date-time-yellow.svg": 32412,
	"./icon/date-time.svg": 68915,
	"./icon/device.svg": 36781,
	"./icon/device_1.svg": 46817,
	"./icon/diamon.svg": 54351,
	"./icon/earm.svg": 73890,
	"./icon/excel_export_16_16.svg": 81357,
	"./icon/expand.svg": 28047,
	"./icon/expand_18_18.svg": 11931,
	"./icon/eyes-close.svg": 62086,
	"./icon/face.svg": 70520,
	"./icon/facebook.svg": 95015,
	"./icon/favorite_blue.svg": 17846,
	"./icon/favorite_white.svg": 31941,
	"./icon/flag_en.svg": 19805,
	"./icon/flag_ko.svg": 32714,
	"./icon/flag_vi.svg": 18383,
	"./icon/fly.svg": 6402,
	"./icon/future.svg": 74070,
	"./icon/global-lang.svg": 93055,
	"./icon/gold-icon.svg": 15457,
	"./icon/google-plus.svg": 1735,
	"./icon/group.svg": 80104,
	"./icon/hamberger_icon-dark.svg": 61097,
	"./icon/hamberger_icon.svg": 99412,
	"./icon/hight.svg": 71949,
	"./icon/icon-chat.svg": 61271,
	"./icon/icon-close-toast.svg": 8361,
	"./icon/icon-close.svg": 97523,
	"./icon/icon-copy.svg": 14374,
	"./icon/icon-error-input.svg": 29842,
	"./icon/icon-error.svg": 32233,
	"./icon/icon-export-history.svg": 33996,
	"./icon/icon-export.svg": 8435,
	"./icon/icon-face-dark.svg": 21039,
	"./icon/icon-face.svg": 10102,
	"./icon/icon-fb.svg": 99413,
	"./icon/icon-futures-spot.svg": 92384,
	"./icon/icon-get-link.svg": 45040,
	"./icon/icon-get-reward.svg": 33541,
	"./icon/icon-in-referral-dark.svg": 65247,
	"./icon/icon-in-referral.svg": 41286,
	"./icon/icon-invite-friend.svg": 83563,
	"./icon/icon-linkedin.svg": 63523,
	"./icon/icon-no-data.svg": 17973,
	"./icon/icon-open-history-black-dark.svg": 57397,
	"./icon/icon-open-history-black.svg": 91656,
	"./icon/icon-open-history-green.svg": 86616,
	"./icon/icon-order-success.svg": 75113,
	"./icon/icon-plus.svg": 43813,
	"./icon/icon-spot-order.svg": 28454,
	"./icon/icon-success.svg": 16634,
	"./icon/icon-trade-history-black-dark.svg": 893,
	"./icon/icon-trade-history-black.svg": 1504,
	"./icon/icon-trade-history-green.svg": 54016,
	"./icon/icon-twitter-referral-dark.svg": 42073,
	"./icon/icon-twitter-referral.svg": 72804,
	"./icon/icon-twitter.svg": 55706,
	"./icon/icon-verified.svg": 81005,
	"./icon/icon-warning.svg": 22239,
	"./icon/identification.svg": 67045,
	"./icon/info-gi-mobile.svg": 87275,
	"./icon/info-gi.svg": 46888,
	"./icon/infor-dark.svg": 47080,
	"./icon/infor-light.svg": 82984,
	"./icon/infor.svg": 78747,
	"./icon/insta.svg": 13836,
	"./icon/inta.svg": 14019,
	"./icon/invalid-modal-light.svg": 1415,
	"./icon/invalid-modal.svg": 65436,
	"./icon/like.svg": 84030,
	"./icon/link.svg": 85727,
	"./icon/lock.svg": 79962,
	"./icon/log-out.svg": 40612,
	"./icon/logo_coin_m_dark.svg": 40725,
	"./icon/logo_coin_m_light.svg": 95347,
	"./icon/logo_usd_m_dark.svg": 74018,
	"./icon/logo_usd_m_light.svg": 77242,
	"./icon/logout.svg": 6069,
	"./icon/money-data.svg": 93494,
	"./icon/moon-light.svg": 85207,
	"./icon/moon.svg": 15180,
	"./icon/mountain.svg": 68634,
	"./icon/note-warning.svg": 46304,
	"./icon/notice.svg": 87063,
	"./icon/overview_wallet.svg": 54682,
	"./icon/phone.svg": 99753,
	"./icon/question-circle.svg": 23056,
	"./icon/referral.svg": 3388,
	"./icon/resend-email.svg": 98613,
	"./icon/resetMail.svg": 8577,
	"./icon/reward_center.svg": 41554,
	"./icon/safety.svg": 18681,
	"./icon/saving.svg": 61445,
	"./icon/security.svg": 21901,
	"./icon/send-mail-success-dark.svg": 39614,
	"./icon/send-mail-success.svg": 60085,
	"./icon/setting.svg": 71541,
	"./icon/sliver-icon.svg": 60456,
	"./icon/snap.svg": 61355,
	"./icon/social/icon-facebook.svg": 56243,
	"./icon/social/icon-google-plus.svg": 42739,
	"./icon/social/icon-instagram3.svg": 50592,
	"./icon/social/icon-linkedin.svg": 59781,
	"./icon/social/icon-reddit3.svg": 8342,
	"./icon/social/icon-telegram.svg": 66058,
	"./icon/social/icon-twitter.svg": 42396,
	"./icon/social/icon-wechat.svg": 48589,
	"./icon/social/icon-weibo.svg": 78737,
	"./icon/social/icon-whatsapp3.svg": 34708,
	"./icon/social/icon-youtube.svg": 29730,
	"./icon/social/icon-youtube3.svg": 52733,
	"./icon/spot.svg": 83411,
	"./icon/staking.svg": 7202,
	"./icon/star_blue.svg": 41938,
	"./icon/star_gray.svg": 99535,
	"./icon/success.svg": 93076,
	"./icon/successCheck-dark.svg": 15489,
	"./icon/successCheck.svg": 96252,
	"./icon/sun-light.svg": 90700,
	"./icon/sun.svg": 56447,
	"./icon/teth.svg": 22606,
	"./icon/trace2.svg": 75920,
	"./icon/traced.svg": 27918,
	"./icon/transaction_history.svg": 32168,
	"./icon/tweet.svg": 94194,
	"./icon/tweeter.svg": 54267,
	"./icon/usd.svg": 63145,
	"./icon/usdt.svg": 78503,
	"./icon/user_21_21.svg": 99402,
	"./icon/user_black.svg": 83638,
	"./icon/user_blue.svg": 13621,
	"./icon/warning-gi.svg": 62454,
	"./icon/warning-mail-invalid-dark.svg": 12710,
	"./icon/warning-mail-invalid.svg": 37485,
	"./icon/www.svg": 21560,
	"./icon/youtube.svg": 27174,
	"./iconCopy-dark.svg": 45632,
	"./iconCopy.svg": 65571,
	"./icon_chart_convert-dark.svg": 92750,
	"./icon_chart_convert.svg": 1221,
	"./icon_search-dark.svg": 98956,
	"./icon_search.svg": 99735,
	"./icon_x_dark.svg": 27328,
	"./icon_x_light.svg": 28944,
	"./iconoir_cancel.svg": 89375,
	"./icons/ArrowsLeftRight-dark.svg": 8112,
	"./icons/ArrowsLeftRight.svg": 8691,
	"./icons/bothSellBuy-dark.svg": 14682,
	"./icons/bothSellBuy.svg": 73465,
	"./icons/buy-dark.svg": 40523,
	"./icons/buy.svg": 56298,
	"./icons/icon-close-message.svg": 1168,
	"./icons/icon-exit-expand.svg": 29979,
	"./icons/icon-expand.svg": 62562,
	"./icons/sell-dark.svg": 54563,
	"./icons/sell.svg": 90450,
	"./icons/swap-btn.svg": 54140,
	"./imgInvite.svg": 60563,
	"./imgReward.svg": 8949,
	"./imgYourLink.svg": 60253,
	"./info-tooltip.svg": 50781,
	"./korea-flag.svg": 15002,
	"./landing/bitcoin1.svg": 8764,
	"./landing/bitcoin2.svg": 11087,
	"./landing/icon-BTC.svg": 65226,
	"./landing/icon-asc.svg": 62632,
	"./landing/icon-desc.svg": 95286,
	"./landing/icon-nodata-dark.svg": 28225,
	"./landing/icon-nodata.svg": 56508,
	"./landing/icon-search-dark.svg": 166,
	"./landing/icon-search.svg": 62637,
	"./line.svg": 99505,
	"./lock.svg": 97026,
	"./login/network.svg": 73497,
	"./logo-red2.svg": 61002,
	"./logo/SotaExLogo.svg": 61516,
	"./logo/logo-3.svg": 87480,
	"./logo/logo-amanpuri.svg": 66040,
	"./logo/logo-amanpuri2.svg": 97242,
	"./mail-icon.svg": 22584,
	"./mail-login.svg": 82870,
	"./mobile/chart.svg": 24516,
	"./mobile/copper-icon.svg": 10399,
	"./mobile/copy_add.svg": 4763,
	"./mobile/eye.svg": 8019,
	"./mobile/eye_non.svg": 86359,
	"./mobile/gold-icon.svg": 6072,
	"./mobile/hide-assets.svg": 86894,
	"./mobile/landing/PIE.svg": 26686,
	"./mobile/landing/TriangleUp.svg": 72523,
	"./mobile/landing/arrow-down.svg": 32144,
	"./mobile/landing/arrow-up.svg": 3043,
	"./mobile/landing/candle.svg": 26783,
	"./mobile/landing/candle_act.svg": 79398,
	"./mobile/landing/close-icon.svg": 11134,
	"./mobile/landing/deposit.svg": 99674,
	"./mobile/landing/deposit1.svg": 17655,
	"./mobile/landing/depth.svg": 32647,
	"./mobile/landing/depth_act.svg": 15134,
	"./mobile/landing/down.svg": 9492,
	"./mobile/landing/english.svg": 78520,
	"./mobile/landing/favorites-icon.svg": 37315,
	"./mobile/landing/favourite.svg": 10697,
	"./mobile/landing/flag.svg": 4422,
	"./mobile/landing/friends.svg": 55203,
	"./mobile/landing/gain_ico.svg": 18219,
	"./mobile/landing/gain_ico_act.svg": 8482,
	"./mobile/landing/icon-arrow.svg": 31351,
	"./mobile/landing/icon1.svg": 46136,
	"./mobile/landing/link.svg": 54648,
	"./mobile/landing/logo.svg": 41149,
	"./mobile/landing/logomango.svg": 10981,
	"./mobile/landing/looser_ico.svg": 50258,
	"./mobile/landing/looser_ico_act.svg": 84483,
	"./mobile/landing/menu.svg": 19837,
	"./mobile/landing/paid.svg": 54818,
	"./mobile/landing/searchIcon.svg": 78223,
	"./mobile/landing/start-box.svg": 87052,
	"./mobile/landing/support_icon.svg": 31627,
	"./mobile/landing/user.svg": 1129,
	"./mobile/landing/vietnam.svg": 62826,
	"./mobile/landing/withdraw.svg": 77374,
	"./mobile/landing/withdraw1.svg": 85347,
	"./mobile/nodata.svg": 89729,
	"./mobile/qrCode.svg": 12586,
	"./mobile/security/google_auth.svg": 43701,
	"./mobile/security/identity.svg": 30555,
	"./mobile/security/language-flag.svg": 16170,
	"./mobile/security/level.svg": 44029,
	"./mobile/security/log.svg": 1549,
	"./mobile/security/referral.svg": 30238,
	"./mobile/show-assets.svg": 99067,
	"./mobile/sliver-icon.svg": 15985,
	"./mobile/x-circle.svg": 92793,
	"./monas-dark.svg": 56588,
	"./monas-white.svg": 85111,
	"./note_icon.svg": 76517,
	"./pen.svg": 75388,
	"./qr-code-login.svg": 14316,
	"./qr-code.svg": 14512,
	"./question-mark.svg": 57463,
	"./rebate/rating-award.svg": 55314,
	"./referral-program.svg": 68615,
	"./save-csv.svg": 47783,
	"./save.svg": 4796,
	"./search.svg": 91599,
	"./search_black.svg": 97795,
	"./spot-icon.svg": 64191,
	"./spot-wallet.svg": 88283,
	"./star-uncheck.svg": 10175,
	"./star.svg": 18775,
	"./success.svg": 92572,
	"./switch-icon.svg": 83763,
	"./telegram.svg": 78646,
	"./to-icon.svg": 76954,
	"./tranferSucess.svg": 52933,
	"./transfer_icon.svg": 66778,
	"./transfer_icon_dark.svg": 78385,
	"./usa-flag.svg": 98551,
	"./usd-coin.svg": 40657,
	"./vietnam-flag.svg": 94712,
	"./wallet/bgr-security-mobile.svg": 40302,
	"./wallet/bgr-security.svg": 92351,
	"./wallet/bgr-wallet-mobile.svg": 40881,
	"./wallet/calendar_icon.svg": 80731,
	"./wallet/checkbox_active_icon.svg": 22219,
	"./wallet/convert_icon.svg": 83152,
	"./wallet/copy-icon.svg": 6998,
	"./wallet/deposit_icon.svg": 76377,
	"./wallet/exportIcon.svg": 6830,
	"./wallet/export_icon.svg": 90207,
	"./wallet/icon_search-dark.svg": 94424,
	"./wallet/icon_search.svg": 25739,
	"./wallet/no_fund_icon.svg": 82096,
	"./wallet/qr-code-icon.svg": 3750,
	"./wallet/search_icon.svg": 29917,
	"./wallet/tranfer_icon.svg": 64513,
	"./wallet/tranfersIconOverview-dark.svg": 85389,
	"./wallet/tranfersIconOverview.svg": 70128,
	"./wallet/withdrawal_icon.svg": 38650,
	"./withdraw_icon.svg": 7303,
	"./withdraw_icon_dark.svg": 72006,
	"./withdrawal-address.svg": 46797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36599;